import { useConfigApi } from '~/composables/api/useConfigApi'
import { useHandleException } from '#imports'
import { useConfigStore } from '~/store/useConfigStore'

export default defineNuxtRouteMiddleware(async () => {
  const { fetch } = useConfigApi()
  const store = useConfigStore()

  try {
    const { data } = await fetch()

    store.$state = data
  }
  catch (e: unknown) {
    useHandleException(e)
  }
})
